"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TweekKeySplitJoin = {
    split: function (key) {
        return key.toLowerCase().split('/');
    },
    join: function (fragments) {
        return fragments.join('/');
    },
};
//# sourceMappingURL=split-join.js.map